import React, { memo, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { components } from "react-select";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, AbsDropDown, Input } from "abs-ui-components";

import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import {
	preventScientificNotation,
	roundOff,
} from "../../../services/utilities";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";

const baseUrl = process.env.REACT_APP_BASE_URL;

const PortOfRegistrySingleValue = (props) => {
	return (
		<components.SingleValue {...props}>
			{props.data.label}
		</components.SingleValue>
	);
};

const VesselIdentificationFormGroup = (props) => {
	
	const {
		control,
		formState: { errors },
		trigger,
		setValue,
		getValues,
	} = useFormContext();
	const [isAutoPopulate, setIsAutoPopulate] = useState(false);
	const { ImoVesselTypeMst, MrvVesselTypeMst, UkVesselTypeMst } = props.vesselData || {};

	const mrvVesselTypes = props.masterData?.[2]?.GetMrvVesselType
		? props.masterData[2]?.GetMrvVesselType.map((e) => ({
			...e,
			value: e.Value,
			label: e.Value,
		}))
		: [];
		const UKVesselTypes = props.masterData?.[10]?.GetUkVesselType
		? props.masterData[10]?.GetUkVesselType.map((e) => ({
				...e,
				value: e.Value,
				label: e.Value,
		  }))
		: [];

	const imoVesselTypes =
		props.masterData?.[1]?.GetImoVesselType
			? props.masterData[1]?.GetImoVesselType.map((e) => ({
				...e,
				value: e.Value,
				label: e.Value,
			}))
			: [];

	const imoLoadOptions = async (inputValue) => {
		if (!inputValue?.length) {
			setValue("vesselIdentifications.vesselName", "");
			setValue("vesselIdentifications.callSign", "");
			setValue(`vesselAttributes.grossTonnage`, "");
			setValue(`vesselAttributes.netTonnage`, "");
			setValue(`vesselAttributes.deadweight`, "");
			setValue(`vesselAttributes.lengthBetweenPerpendiculars`, "");
			setValue(`vesselAttributes.beam`, "");
			setValue(`vesselAttributes.maximumDraughtAtSummerLoadLine`, "");
			return;
		}
		try {
			const response = await axiosHttp.get(
				`${baseUrl}api/MyFleet/SearchByImo?imoNumber=${inputValue}`
			);

			if (response?.data?.Data?.length > 0) {
				props.setImoBasedData(response?.data?.Data);
				setValue(
					"vesselIdentifications.vesselName",
					response?.data?.Data[0]?.VesselName
				);
				setValue(
					"vesselIdentifications.callSign",
					response?.data?.Data[0]?.CallSign
				);
				setValue(
					`vesselAttributes.grossTonnage`,
					`${roundOff(response?.data?.Data[0]?.GrossTonnage)}`
				);
				setValue(
					`vesselAttributes.netTonnage`,
					`${roundOff(response?.data?.Data[0]?.NetTonnage)}`
				);
				setValue(
					`vesselAttributes.deadweight`,
					`${roundOff(response?.data?.Data[0]?.DeadWeight)}`
				);
				setValue(
					`vesselAttributes.lengthBetweenPerpendiculars`,
					response?.data?.Data[0]?.LengthBetweenPerp !== 0
						? `${roundOff(
							response?.data?.Data[0]?.LengthBetweenPerp
						)}`
						: null
				);
				setValue(
					`vesselAttributes.beam`,
					response?.data?.Data[0]?.Beam !== 0
						? `${roundOff(response?.data?.Data[0]?.Beam)}`
						: null
				);
				setValue(
					`vesselAttributes.maximumDraughtAtSummerLoadLine`,
					response?.data?.Data[0]?.MaxDraughtSummerLoadline !== 0
						? `${roundOff(
							response?.data?.Data[0]
								?.MaxDraughtSummerLoadline
						)}`
						: null
				);
				setIsAutoPopulate(true);
			}
			if (!props.vesselMstId) {
				if (response.data?.Data?.length === 0 && isAutoPopulate) {
					setValue("vesselIdentifications.vesselName", "");
					setValue("vesselIdentifications.callSign", "");
					setValue(`vesselAttributes.grossTonnage`, "");
					setValue(`vesselAttributes.netTonnage`, "");
					setValue(`vesselAttributes.deadweight`, "");
					setValue(
						`vesselAttributes.lengthBetweenPerpendiculars`,
						""
					);
					setValue(`vesselAttributes.beam`, "");
					setValue(
						`vesselAttributes.maximumDraughtAtSummerLoadLine`,
						""
					);
					setIsAutoPopulate(false);
					return;
				}
			}
			if (response?.data?.Data && !isAutoPopulate) {
				const vesselIdentificationFormValues = getValues(
					"vesselIdentifications"
				);

				const vesselParticularsFormValues =
					getValues("vesselAttributes");

				setValue(
					"vesselIdentifications.vesselName",
					vesselIdentificationFormValues?.vesselName
						? vesselIdentificationFormValues?.vesselName
						: ""
				);
				setValue(
					"vesselIdentifications.callSign",
					vesselIdentificationFormValues?.callSign
						? vesselIdentificationFormValues?.callSign
						: ""
				);
				setValue(
					`vesselAttributes.grossTonnage`,
					vesselParticularsFormValues?.grossTonnage
						? vesselParticularsFormValues?.grossTonnage
						: ""
				);
				setValue(
					`vesselAttributes.netTonnage`,
					vesselParticularsFormValues?.netTonnage
						? vesselParticularsFormValues?.netTonnage
						: ""
				);
				setValue(
					`vesselAttributes.deadweight`,
					vesselParticularsFormValues?.deadweight
						? vesselParticularsFormValues?.deadweight
						: ""
				);
				setValue(
					`vesselAttributes.lengthBetweenPerpendiculars`,
					vesselParticularsFormValues?.lengthBetweenPerpendiculars
						? vesselParticularsFormValues?.lengthBetweenPerpendiculars
						: ""
				);
				setValue(
					`vesselAttributes.beam`,
					vesselParticularsFormValues?.beam
						? vesselParticularsFormValues?.beam
						: ""
				);
				setValue(
					`vesselAttributes.maximumDraughtAtSummerLoadLine`,
					vesselParticularsFormValues?.maximumDraughtAtSummerLoadLine
						? vesselParticularsFormValues?.maximumDraughtAtSummerLoadLine
						: ""
				);  
			}
		} catch (error) {
			emitToasterMsg("error", "Error", error.message);
		}
	};

	const portOfRegistryOptions = async (inputValue) => {
		const dataToSend = {
			globalFilter: inputValue,
			filters: [],
			pagination: {
				page: 1,
				pageSize: 50,
			},
			sortOption: {
				sortField: "",
				isAscending: true,
			},
		};
		try {
			const response = await axiosHttp.post(
				`${baseUrl}api/PortCode/Query`,
				dataToSend
			);
			const formattedIMOOptions = response.data.Data.map((item) => {
				return {
					label: `${item.PortName}`,
					value: `${item.PortCode}`,
					portCodeMstId: item.PortCodeMstId,
				};
			});
			return formattedIMOOptions;
		} catch (error) {
			emitToasterMsg("error", "Error", error.message);
		}
	};

	const handleBlur = async (field) => {
		await trigger(field);
	};

	const handleImoNumberBlur = (field, value) => {
		trigger(field);
		imoLoadOptions(value);
	};

	const enhancedImovesselType = {
		...ImoVesselTypeMst,
		value: ImoVesselTypeMst?.Value,
		label: ImoVesselTypeMst?.Value,
	};
	const enhancedMrvvesselType = {
		...MrvVesselTypeMst,
		value: MrvVesselTypeMst?.Value,
		label: MrvVesselTypeMst?.Value,
	};
	const enhancedUkVesselType = {
		...UkVesselTypeMst,
		value: UkVesselTypeMst?.Value,
		label: UkVesselTypeMst?.Value,
		
	};

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol md="12" className="mt-3">
					<Label required bold name="IMO Number" className="mb-1" />
					<Controller
						name="vesselIdentifications.imoNumber"
						control={control}
						rules={
							props?.regulations?.trim() !== "EUMRV" &&
								props?.regulations?.trim() !== "UKMRV" &&
								props?.regulations?.trim() !== "DCS"
								? {
									required:
										"Please provide a 7 digit IMO number",
									validate: (value) =>
										value.length === 7 ||
										"IMO number must be exactly 7 characters",
								}
								: {}
						}
						defaultValue={
							props?.vesselMstId
								? props.vesselData?.ImoNumber?.trim()
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="vessel_imo_number"
								type="number"
								autoFocus={false}
								value={field?.value}
								onChange={(e) => field.onChange(e)}
								className="input-height"
								required
								min="1"
								minLength={7}
								maxLength={7}
								onBlur={(e) =>
									handleImoNumberBlur(field.name, field.value)
								}
								onWheel={(e) => e.target.blur()}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
								onKeyDown={preventScientificNotation}
								disabled={
									(!props.isEnrollVessel ||
										props.vesselMstId) &&
									(props?.disabled ||
										props?.regulations?.trim() ===
										"EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
							/>
						)}
					/>
					{errors.vesselIdentifications &&
						errors.vesselIdentifications.imoNumber && (
							<div className="error-msg">
								{errors.vesselIdentifications.imoNumber.message}
							</div>
						)}
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label required bold name="Vessel Name" className="mb-1" />
					<Controller
						name="vesselIdentifications.vesselName"
						control={control}
						rules={{
							required: "Please enter the vessel name",
						}}
						defaultValue={
							props?.vesselMstId
								? props.vesselData?.VesselName
								: ""
						}
						render={({ field }) => (
							<>
								<Input
									name={field.name}
									id="vessel_vessel_name"
									autoFocus={false}
									value={field.value}
									onChange={(e) => field.onChange(e)}
									className="input-height field-to-uppercase"
									required
									maxLength={60}
									onBlur={(e) => handleBlur(field.name)}
									disabled={props?.disabled}
								/>
							</>
						)}
					/>
					{errors.vesselIdentifications &&
						errors.vesselIdentifications.vesselName && (
							<div className="error-msg">
								{
									errors.vesselIdentifications.vesselName
										.message
								}
							</div>
						)}
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label required bold name="Call Sign" className="mb-1" />
					<Controller
						name="vesselIdentifications.callSign"
						control={control}
						rules={{
							required: "Please enter the call sign",
						}}
						defaultValue={
							props?.vesselMstId ? props.vesselData?.CallSign : ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="vessel_call_sign"
								autoFocus={false}
								value={field.value}
								onChange={(e) => field.onChange(e)}
								className="input-height field-to-uppercase"
								required
								maxLength={10}
								onBlur={(e) => handleBlur(field.name)}
								disabled={props?.disabled}
							/>
						)}
					/>
					{errors.vesselIdentifications &&
						errors.vesselIdentifications.callSign && (
							<div className="error-msg">
								{errors.vesselIdentifications.callSign.message}
							</div>
						)}
				</MDBCol>
				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="IMO Vessel Type"
						className="mb-1"
					/>
					<Controller
						name="vesselIdentifications.imovesselTypeId"
						control={control}
						rules={
							props?.regulations?.trim() !== "EUMRV" &&
								props?.regulations?.trim() !== "UKMRV" &&
								props?.regulations?.trim() !== "DCS"
								? {
									required:
										"Please select a IMO vessel type",
								}
								: {}
						}
						defaultValue={
							props?.vesselMstId ? enhancedImovesselType : ""
						}
						render={({ field }) => (
							<div id="vessel_imovessel_type" name={field.name}>
								<AbsDropDown
									options={imoVesselTypes}
									value={field?.value}
									selected={field.value?.label}
									handleChange={field.onChange}
									placeholder="Please Select IMO Vessel Type"
									onBlur={(e) => handleBlur(field.name)}
									disabled={
										!props.isEnrollVessel &&
										(props?.disabled ||
											props?.regulations?.trim() ===
											"EUMRV" ||
											"UKMRV" ||
											"DCS")
									}
								/>
							</div>
						)}
					/>
					{errors.vesselIdentifications &&
						errors.vesselIdentifications.imovesselTypeId && (
							<div className="error-msg">
								{
									errors.vesselIdentifications.imovesselTypeId
										.message
								}
							</div>
						)}
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="EU Vessel Type"
						className="mb-1"
					/>
					<MDBRow className="d-flex">
						<MDBCol md={12}>
							<Controller
								name="vesselIdentifications.mrvvesselTypeId"
								control={control}
								rules={
									props?.regulations?.trim() !== "EUMRV" &&
										props?.regulations?.trim() !== "UKMRV" &&
										props?.regulations?.trim() !== "DCS"
										? {
												required:
													"Please select a EU vessel type",
										  }
										: {}
								}
								defaultValue={
									props?.vesselMstId
										? enhancedMrvvesselType
										: ""
								}
								render={({ field }) => (
									<div id="vessel_mrvvessel_type" name={field.name}>
										<AbsDropDown
											options={mrvVesselTypes}
											selected={field.value?.label}
											handleChange={(selectedItem) => {
												field.onChange(selectedItem);
											}}
											placeholder="Please Select EU Vessel Type"
											onBlur={(e) =>
												handleBlur(field.name)
											}
											disabled={
												!props.isEnrollVessel &&
												(props?.disabled ||
													props?.regulations?.trim() ===
													"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
										/>
									</div>
								)}
							/>
							{errors.vesselIdentifications &&
								errors.vesselIdentifications
									.mrvvesselTypeId && (
									<div className="error-msg">
										{
											errors.vesselIdentifications
												.mrvvesselTypeId.message
										}
									</div>
								)}
						</MDBCol>
					</MDBRow>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="UK Vessel Type"
						className="mb-1"
					/>
					<MDBRow className="d-flex">
						<MDBCol md={12}>
							<Controller
								name="vesselIdentifications.ukvesselTypeId"
								control={control}
								rules={
									props?.regulations?.trim() !== "EUMRV" &&
									props?.regulations?.trim() !== "UKMRV" &&
									props?.regulations?.trim() !== "DCS"
										? {
												required:
													"Please select a UK vessel type",
										  }
										: {}
								}
								defaultValue={
									props?.vesselMstId
										? enhancedUkVesselType
										: ""
								}
								render={({ field }) => (
									<div id="vessel_ukvessel_type">
										<AbsDropDown
											options={UKVesselTypes}
											selected={field.value?.label}
											handleChange={(selectedItem) => {
												field.onChange(selectedItem);
											}}
											placeholder="Please Select UK Vessel Type"
											onBlur={(e) =>
												handleBlur(field.name)
											}
											disabled={
												!props.isEnrollVessel &&
												(props?.disabled ||
													props?.regulations?.trim() ===
														"EUMRV" ||
													"UKMRV" ||
													"DCS")
											}
										/>
									</div>
								)}
							/>
							{errors.vesselIdentifications &&
								errors.vesselIdentifications
									.ukvesselTypeId && (
									<div className="error-msg">
										{
											errors.vesselIdentifications
												.ukvesselTypeId.message
										}
									</div>
								)}
						</MDBCol>
					</MDBRow>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label bold name="Other Ship Type" className="mb-1" />
					<Controller
						name="vesselIdentifications.otherMrvVesselTypeName"
						control={control}
						defaultValue={
							props.vesselMstId &&
								props.vesselData?.OtherMrvVesselTypeName
								? props.vesselData?.OtherMrvVesselTypeName
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="vessel_other_mrvvessel_type"
								autoFocus={false}
								value={field.value}
								onChange={(e) => field.onChange(e)}
								className="input-height"
								disabled={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						required
						bold
						name="Port of Registry"
						className="mb-1"
					/>
					<Controller
						name="vesselIdentifications.portOfRegistry"
						control={control}
						rules={{
							required:
								"Please select or enter a port of registration",
						}}
						defaultValue={
							props.vesselData?.VesselMstId
								? {
									label: props?.vesselData?.PortCodeMst
										?.PortName,
									value: props?.vesselData?.PortCodeMst
										?.PortCode,
									portCodeMstId:
										props?.vesselData?.PortCodeMst
											?.PortCodeMstId,
								}
								: null
						}
						render={({ field }) => (
							<div name={field.name}>
								<AutocompleteDropdown
									id="vessel_port_of_registry"
									{...field}
									disabled={props?.disabled}
									isClearable
									loadOptions={portOfRegistryOptions}
									placeholder="Search Port of Registry"
									getOptionLabel={(option) =>
										`${option.label} - ${option.value}`
									}
									components={{
										SingleValue: PortOfRegistrySingleValue,
									}}
									defaultOptions={
										props.vesselData?.VesselMstId
											? {
												label: props?.vesselData
													?.PortCode?.PortName,
												value: props?.vesselData
													?.PortCode?.PortCode,
												portCodeMstId:
													props?.vesselData?.PortCode
														?.PortCodeMstId,
											}
											: null
									}
								/>
							</div>
						)}
					/>
					{errors.vesselIdentifications &&
						errors.vesselIdentifications.portOfRegistry && (
							<div className="error-msg">
								{
									errors.vesselIdentifications.portOfRegistry
										.message
								}
							</div>
						)}
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label bold name="Flag" />

					{props.vesselMstId && props.vesselData?.PortCodeMst ? (
						<>
							<Controller
								name="vesselIdentifications.flag"
								control={control}
								defaultValue={
									props.vesselMstId &&
										props.vesselData?.PortCodeMst
										? props.vesselData?.PortCodeMst
											?.CountryName
										: ""
								}
								render={({ field }) => (
									<Input
										name={field.name}
										id="vessel_flag"
										autoFocus={false}
										value={field.value}
										onChange={(e) => field.onChange(e)}
										className="input-height"
										disabled
										readOnly
									/>
								)}
							/>
						</>
					) : (
						""
					)}
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default memo(VesselIdentificationFormGroup);
